import { render } from "./modal-tutte-le-notifiche.vue?vue&type=template&id=c0aec34a&scoped=true"
import script from "./modal-tutte-le-notifiche.vue?vue&type=script&lang=js"
export * from "./modal-tutte-le-notifiche.vue?vue&type=script&lang=js"

import "./modal-tutte-le-notifiche.vue?vue&type=style&index=0&id=c0aec34a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0aec34a"]])

export default __exports__